/**
 * Contêiner dos menus da sala. Em tela cheia só o elemento em fullscreen é renderizado, então menus
 * e avisos precisam abrir DENTRO dele (e não em `document.body`, que é o padrão do Radix).
 * `VideoCallMedia` publica aqui o mesmo elemento que entra em tela cheia.
 */
import { createContext, useContext } from 'react';

const RoomPortalContext = createContext(null);

export const RoomPortalProvider = RoomPortalContext.Provider;

/** @returns {HTMLElement | null} `null` antes de a sala montar: o Radix cai em `document.body`. */
export function useRoomPortalContainer() {
    return useContext(RoomPortalContext);
}
